import { StallActionTypes } from "./constants";

export const stallApiResponseSuccess = (
    actionType: string,
    data: any
) => ({
    type: StallActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const stallApiResponseError = (
    actionType: string,
    error: string
) => ({
    type: StallActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getStalls = (params: {
    page: number;
    limit: number;
    sortType?: string;
    vendorId?: number;
}) => ({
    type: StallActionTypes.GET_STALLS,
    payload: params,
});

export const getStallByIdAction = (stallId: number) => ({
    type: StallActionTypes.GET_STALL_BY_ID,
    payload: stallId,
});

export const addStall = (payload: any) => ({
    type: StallActionTypes.ADD_STALL,
    payload,
});

export const updateStallByIdAction = (payload: any) => ({
    type: StallActionTypes.UPDATE_STALL,
    payload,
});

export const deleteStallByIdAction = (payload: {
    vendorId: number;
    stallId: number;
}) => ({
    type: StallActionTypes.DELETE_STALL,
    payload,
});

export const resetStall = () => ({
    type: StallActionTypes.RESET,
});